import React, { useState } from "react";
import { toast } from "sonner";
import { finApi, finErr } from "@/lib/financeApi";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";

/** Weekly card: has this week's rent been passed to the landlord? Weeks up to the paid-through date start ticked (untick allowed); no rent collected → never ticked. */
export function LandlordTick({ rid, w, onDone }) {
  const sa = useIsSuper();
  const [busy, setBusy] = useState(false);
  if (!w.due) return null;
  const waiting = !(w.rent_paid > 0) && w.rent_pending > 0;
  const lock = !sa || busy || (!w.landlord_paid && !(w.rent_paid > 0));
  const flip = async () => {
    setBusy(true);
    try { await finApi.post("/landlord-passthrough/tick", { resident_id: rid, week: w.week_ending, checked: !w.landlord_paid }); onDone?.(); }
    catch (e) { toast.error(finErr(e)); }
    setBusy(false);
  };
  return (
    <label className={`flex items-center gap-2 pt-2 border-t border-white/5 text-[11px] ${lock ? "cursor-default" : "cursor-pointer"}`} data-testid={`flow-duesr-ll-paid-row-${w.week_ending}`}>
      <input type="checkbox" checked={!!w.landlord_paid} disabled={lock} onChange={flip} data-testid={`flow-duesr-ll-paid-${w.week_ending}`} className="accent-[#c9a961]" />
      <span className={w.landlord_paid ? "text-emerald-300" : "text-nex-muted"}>
        {!(w.rent_paid > 0) ? (waiting ? "Paid to landlord · not yet — rent still waiting on the invoice" : "Not paid to landlord · no rent collected this week") : w.landlord_through ? "Rent paid to landlord · covered by the paid-through date (untick if it wasn't)" : w.landlord_paid ? "Rent paid to landlord" : waiting ? "Paid to landlord · not yet — rent still waiting on the invoice" : w.rent_paid > 0 ? "Paid to landlord?" : "Paid to landlord · no rent received this week"}
      </span>
    </label>
  );
}
